// extracted by mini-css-extract-plugin
export default {"container":"Requests_container__5FcGn","requests_list":"Requests_requests_list__JKrCC"};